module.exports = __webpack_public_path__ + "static/media/get-started.7be9aa62.png";